export enum DropdownTypesEnum {
    normal,
    borderless
}
